import * as betprofessor from './RaceResults.styles.betprofessor';
import * as betroyale from './RaceResults.styles.betroyale';
import * as fiestabet from './RaceResults.styles.fiestabet';
import * as goldenrush from './RaceResults.styles.goldenrush';
import * as juicybet from './RaceResults.styles.juicybet';
import * as puntcity from './RaceResults.styles.puntcity';
import * as puntgenie from './RaceResults.styles.puntgenie';
import * as questbet from './RaceResults.styles.questbet';
import * as sterlingparker from './RaceResults.styles.sterlingparker';
import * as vikingbet from './RaceResults.styles.vikingbet';
import * as volcanobet from './RaceResults.styles.volcanobet';
import * as junglebet from './RaceResults.styles.junglebet';
import * as sugarcastle from './RaceResults.styles.sugarcastle';
import * as oldgill from './RaceResults.styles.oldgill';
import * as buffalobet from './RaceResults.styles.buffalobet';
import * as titanbet from './RaceResults.styles.titanbet';
import * as slambet from './RaceResults.styles.slambet';
import * as gigabet from './RaceResults.styles.gigabet';
import * as betstride from './RaceResults.styles.betstride';
import * as templebet from './RaceResults.styles.templebet';
import * as goldenbet888 from './RaceResults.styles.goldenbet888';
import * as hyperbet from './RaceResults.styles.hyperbet';
import * as bet777 from './RaceResults.styles.bet777';
import * as chromabet from './RaceResults.styles.chromabet';
import * as bet575 from './RaceResults.styles.bet575';
import * as betblast from './RaceResults.styles.betblast';
import * as pyramidbet from './RaceResults.styles.pyramidbet';
import * as magnumbet from './RaceResults.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
